import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { updateFormField } from 'store/forms/actions';
import { TabsTimeline } from 'components';
import { isNil } from 'lodash';
import { Steps } from './steps';
import { useNavigate } from 'react-router-dom';
import { startNew } from '../../../store/forms/actions';
import { isBeneficiary } from '../../../utils';
import { Spin } from 'antd';
import { MainFormFooter } from './components/MainFormFooter';

const MainForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const [current, setCurrent] = useState(0);
  const currentSubTab = useSelector(state => state.forms.carrier.currentSubTab);
  const user = useSelector(state => state.user);
  const task = useSelector(state => state.forms.task);
  const viewMode = useSelector(state => state.forms.carrier.viewMode);
  const banner = useSelector(state => state.appTrack?.banner);
  const carrier = useSelector(state => state.forms.carrier);

  useEffect(() => {
    if (window.location.pathname.includes('view')) {
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'viewMode',
          value: true,
        })
      );
    }
  }, [dispatch, params.id]);

  useEffect(() => {
    dispatch(startNew(params.id));
  }, [params.id, dispatch]);

  const renderBeneficiary = parseFlag => {
    return Steps(parseFlag);
  };

  return false ? (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Spin size="large" />
    </div>
  ) : (
    <div className="main-mainforms">
      <div className="main-container">
        <div id="mainforms-page-1" className="investor-form-container">
          {!isNil(current) && (
            <div className="investor-steps-footer-container">
              {!viewMode &&
                banner?.render &&
                banner?.message &&
                isBeneficiary(user?.groups) && (
                  <div className="stepper-warning-message">
                    <div>{banner?.message}</div>
                  </div>
                )}
              {!viewMode &&
                isBeneficiary(user?.groups) &&
                (carrier.businessSize == 'Μεσαία' ||
                  carrier.businessSize == 'Μεγάλη') && (
                  <div className="stepper-warning-message error-message">
                    <div>
                      Δεν πληροίτε τις προϋποθέσεις υποβολής αίτησης στο
                      πρόγραμμα, καθώς σύμφωνα με τη δήλωση ΜΜΕ, η επιχείρησή
                      σας δεν κατατάσσεται στην κατηγορία των Πολύ Μικρών ή
                      Μικρών Επιχειρήσεων.{' '}
                    </div>
                  </div>
                )}
              {isBeneficiary(user?.groups) &&
                task.taskName == 'task.name.application_evaluated' && (
                  <div className="stepper-warning-message">
                    <div>
                      Σε περίπτωση που επιθυμείτε να προσθέσετε νέες δαπάνες στο
                      επενδυτικό σας πλάνο, σας ενημερώνουμε ότι δεν είναι
                      δυνατή η τροποποίηση αίτησης που έχει ήδη υποβληθεί. Για
                      τον λόγο αυτό, παρακαλούμε να προχωρήσετε πρώτα στην
                      ακύρωση της τρέχουσας αίτησής σας και στη συνέχεια να
                      υποβάλετε νέα αίτηση με το σύνολο των δαπανών που
                      επιθυμείτε να συμπεριλάβετε.
                    </div>
                  </div>
                )}
              <TabsTimeline
                tabs={renderBeneficiary()}
                current={current}
                setCurrent={setCurrent}
                customClass={`custom-tabs-timeline active-tab-${current + 1}`}
              />
              <MainFormFooter currentTab={current} setCurrentTab={setCurrent} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MainForm;
